const segment = require('./segment');
const itinerary = require('./itinerary_prototype');
const passengers = require('./passengers');

function confirmationItinerary(itineraryData) {
    const confirmationItinerary = Object.create(itinerary(itineraryData));
    const segmentsArray = Odigeo._.get(itineraryData, 'itineraries[0].segments');
    const travellersData = Odigeo._.get(itineraryData, 'travellers');

    confirmationItinerary._segments = Odigeo._.map(segmentsArray, (segmentData) => {
        return segment(segmentData);
    });

    confirmationItinerary.getPrice = function() {
        return itineraryData.totalPrice;
    };

    confirmationItinerary.getCurrencyCode = function() {
        return itineraryData.currency;
    };

    confirmationItinerary.getPnr = function() {
        return Odigeo._.get(itineraryData, 'bookingConfirmationSections[0].pnr', '');
    };

    confirmationItinerary.getBookingId = function() {
        return Odigeo._.get(itineraryData, 'bookingId');
    };

    confirmationItinerary.getBookingStatus = function() {
        const status = itineraryData.status || '';
        return Odigeo._.last(status.split('_')).toLowerCase();
    };

    confirmationItinerary._passengers = passengers(Odigeo._.groupBy(travellersData, 'ageType'));

    return confirmationItinerary;
}

module.exports = confirmationItinerary;
